// Globaler 403-Handler für das Web-Plattform-Gate: Wenn ein /api-Aufruf mit
// 403 + Code `web_platform_required` abgelehnt wird (der Tarif enthält keinen
// Browser-Zugang, siehe server/routes.ts), soll die App denselben freundlichen
// Upgrade-Hinweis zeigen wie die vollflächige `SubscriptionGate`-Sperre — statt
// einer rohen Fehlermeldung oder eines stillen Fehlers aus einer Hintergrund-
// Query.
//
// Analog zu subscriptionLock.ts / featureLock.ts: Der Query-Client lebt außerhalb
// des React-Routers und kann nicht selbst navigieren/rendern. Stattdessen meldet
// er den Sperr-Fall über dieses kleine Pub/Sub an eine im Router montierte
// Komponente (WebPlatformLockNotice), die den Hinweis anzeigt.

/** Server-Code für „Web-Plattform nicht im Tarif enthalten" (siehe routes.ts). */
export const WEB_PLATFORM_REQUIRED_CODE = "web_platform_required";

// Einheitliche Texte für den Hinweis. Wird sowohl von der vollflächigen
// `SubscriptionGate`-Sperre als auch vom Toast `WebPlatformLockNotice` genutzt,
// damit beide Oberflächen stets dieselbe Botschaft tragen.
export const WEB_PLATFORM_NOTICE_TITLE =
  "Web-Plattform nicht im Tarif enthalten";
export const WEB_PLATFORM_NOTICE_BODY =
  "Ihr aktueller Tarif enthält keinen Zugang zur Web-Plattform. Sie können die App weiterhin auf dem Smartphone nutzen. Für den Browser-Zugang wechseln Sie zu einem Tarif mit Web-Plattform.";
export const WEB_PLATFORM_NOTICE_ACTION = "Tarife ansehen";

type Listener = () => void;

const listeners = new Set<Listener>();
let lastFired = 0;

/** Registriert einen Listener; gibt eine Cleanup-Funktion zurück. */
export function onWebPlatformRequired(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/**
 * Meldet, dass ein API-Aufruf wegen fehlenden Web-Plattform-Zugangs (403)
 * blockiert wurde. Entprellt, damit gleichzeitige Hintergrund-Queries nicht
 * mehrfach feuern.
 */
export function notifyWebPlatformRequired(): void {
  const now = Date.now();
  if (now - lastFired < 1500) return;
  lastFired = now;
  for (const fn of listeners) fn();
}
